export const formatPrice = (price: number, maximumFractionDigits = 2) =>
  new Intl.NumberFormat('de-DE', {
    currency: 'EUR',
    style: 'currency',
    maximumFractionDigits,
  }).format(price);
